import Contact from './Contact';
const __Contact = Contact;
export { __Contact as Contact };
export default Contact;